// extracted by mini-css-extract-plugin
module.exports = {"emphasize":"EmphasizeText_emphasize__1QhBv"};